import { useState, useEffect } from "react";
import axios from "axios";
import Pagination from "../../components/Pagination";
import Search from "../../components/Search";
import UsersTable from "./UsersTable";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [newUser, setNewUser] = useState({
    userid: "",
    username: "",
    status: "active",
  });

  const [showAddForm, setShowAddForm] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;

  // Fetch users on mount
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(`${API_URL}/users`);
        setUsers(res.data);
        setFilteredData(res.data);
      } catch (error) {
        console.error("Failed to fetch users", error);
      }
    };

    fetchUsers();
  }, [API_URL]);

  const handleAddUser = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(`${API_URL}/users`, newUser);
      const addedUser = res.data;

      const updatedUsers = [addedUser, ...users];
      setUsers(updatedUsers);
      setFilteredData(updatedUsers);
      setNewUser({ userid: "", username: "", status: "active" });
      setShowAddForm(false); // hide form after adding
    } catch (err) {
      console.error("Error adding user:", err);
      alert("Failed to add user.");
    }
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredData.slice(indexOfFirstPost, indexOfLastPost);
  const howManyPages = Math.ceil(filteredData.length / postsPerPage);

  return (
    <div className="container">
      {/* Search Bar */}
      <div className="mb-3">
        <Search data={users} setFilterData={setFilteredData} />
      </div>

      {/* Toggle Add Form Button */}
      <div className="mb-3 text-end">
        <button
          className="btn btn-primary"
          onClick={() => setShowAddForm(!showAddForm)}
        >
          {showAddForm ? "✖ Cancel" : "➕ Add User"}
        </button>
      </div>

      {/* Add User Form */}
      {showAddForm && (
        <form
          onSubmit={handleAddUser}
          className="my-4 border p-3 rounded shadow-sm bg-light"
        >
          <h5>Add New User</h5>
          <div className="row g-2">
            <div className="col-md">
              <input
                type="text"
                placeholder="User ID"
                className="form-control"
                value={newUser.userid}
                onChange={(e) =>
                  setNewUser({ ...newUser, userid: e.target.value })
                }
                required
              />
            </div>
            <div className="col-md">
              <input
                type="text"
                placeholder="Username"
                className="form-control"
                value={newUser.username}
                onChange={(e) =>
                  setNewUser({ ...newUser, username: e.target.value })
                }
                required
              />
            </div>
            <div className="col-md">
              <select
                className="form-select"
                value={newUser.status}
                onChange={(e) =>
                  setNewUser({ ...newUser, status: e.target.value })
                }
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="col-md-auto">
              <button type="submit" className="btn btn-success">
                ✅ Submit
              </button>
            </div>
          </div>
        </form>
      )}

      {/* User Table */}
      <UsersTable currentPosts={currentPosts} />

      {/* Pagination */}
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          <label>Show</label>
          <select
            className="mx-2"
            style={{ width: "60px", height: "30px" }}
            value={postsPerPage}
            onChange={(e) => {
              setPostsPerPage(parseInt(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={500}>500</option>
          </select>
          <span>
            Page {currentPage} of Pages {howManyPages}
          </span>
        </div>

        <div className="mx-5 mb-5">
          <Pagination pages={howManyPages} setCurrentPage={setCurrentPage} />
        </div>
      </div>
    </div>
  );
};

export default Users;
